var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Favorite',{attrs:{"widget":_vm.widget,"data":_vm.data,"editable":true}})}
var staticRenderFns = []

export { render, staticRenderFns }